import { FunctionComponent } from 'react'
import styled, { css, useTheme } from 'styled-components'
import IconButton from '@components/Buttons/IconButton'
import { desktopCSS } from '@measures/responsive'

interface CloseButtonProps {
  className?: string
  onClick: () => void
}

const StyledIconButton = styled(IconButton)`
  ${({
    theme: {
      colors: { staticBlack, staticWhite },
    },
  }) => css`
    border-radius: 50%;
    background: ${staticBlack}80;

    ${desktopCSS(css`
      background: ${staticWhite};

      svg {
        fill: ${staticBlack};
        color: ${staticBlack};
      }
    `)}
  `}
`

const CloseButton: FunctionComponent<CloseButtonProps> = ({
  className,
  onClick,
}) => {
  const theme = useTheme()

  return (
    <StyledIconButton
      className={className}
      ariaLabel="Close"
      buttonSize={40}
      onClick={onClick}
      iconName="xmark-large"
      iconSize={20}
      iconColor={theme.colors.staticWhite}
    />
  )
}

export default CloseButton
